import { render, staticRenderFns } from "./ChatItemTasklist.vue?vue&type=template&id=7317c1f4&"
import script from "./ChatItemTasklist.vue?vue&type=script&lang=js&"
export * from "./ChatItemTasklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports